import { render, staticRenderFns } from "./like-list.vue?vue&type=template&id=24bb9cc2&scoped=true&"
import script from "./like-list.vue?vue&type=script&lang=js&"
export * from "./like-list.vue?vue&type=script&lang=js&"
import style0 from "./like-list.vue?vue&type=style&index=0&id=24bb9cc2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24bb9cc2",
  null
  
)

export default component.exports